export default __webpack_public_path__ + "media/zurb/img/ecommerce/cp_pdp-7974cc477727219477406609350e3a89.png";